import axios, { AxiosResponse } from 'axios'

const recoveryClient = axios.create({ baseURL: process.env.REACT_APP_BACKEND, responseType: 'json' })

type RecoveryApiClient = {
  post: (url: string, body: unknown) => Promise<AxiosResponse<unknown>>
}

export const createPasswordRecoveryApi = (client: RecoveryApiClient) => ({
  request(email: string) {
    return client.post('/user/password-recovery/request', { email })
  },
  complete(challengeId: string, token: string, password: string) {
    return client.post('/user/password-recovery/complete', { challengeId, token, password })
  }
})

const recoveryApi = createPasswordRecoveryApi(recoveryClient)

export const requestPasswordRecovery = recoveryApi.request
export const completePasswordRecovery = recoveryApi.complete
